// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav_sp-module--nav--3RuPO","opened":"nav_sp-module--opened--1Vt_b"};